module.exports = __webpack_public_path__ + "resources/img/img_equipment3.363c65c333e216e7fe745afb4487c333.png";